// @flow
import config from '../package.json';

const ID = `${config.name}/actions/webinarActions.js`;
const createActionName = (name: string) => `app/${ID}/${name}`;

export const FETCH_WEBINAR_LIST_REQUEST = createActionName(
  'FETCH_WEBINAR_LIST_REQUEST',
);
export const FETCH_WEBINAR_LIST_SUCCESS = createActionName(
  'FETCH_WEBINAR_LIST_SUCCESS',
);
export const FETCH_WEBINAR_LIST_FAILURE = createActionName(
  'FETCH_WEBINAR_LIST_FAILURE',
);

export const ENABLE_WEBINAR_RED_DOT = createActionName(
  'ENABLE_WEBINAR_RED_DOT',
);
export const DISABLE_WEBINAR_RED_DOT = createActionName(
  'DISABLE_WEBINAR_RED_DOT',
);

export const PUT_WEBINAR_RED_DOT = createActionName('PUT_WEBINAR_RED_DOT');

export const fetchWebinarListRequest = () => {
  console.log('fetchWebinarListRequest');
  return {
    type: FETCH_WEBINAR_LIST_REQUEST,
    succcessAction: FETCH_WEBINAR_LIST_SUCCESS,
    failureAction: FETCH_WEBINAR_LIST_FAILURE,
  };
};

export const enableWebinarRedDot = () => {
  return {
    type: ENABLE_WEBINAR_RED_DOT,
  };
};

export const disableWebinarRedDot = () => {
  return {
    type: DISABLE_WEBINAR_RED_DOT,
  };
};

export const updateMuleWebinarRedDot = (featureId: string) => {
  console.log('updateMuleWebinarRedDot');
  return {
    type: PUT_WEBINAR_RED_DOT,
    payload: {
      featureId,
    },
  };
};
